import { Navigate } from "react-router-dom";
import { useAppSelector } from "@/store";

/** Render children only if the current user has role === 'admin'.
 *  Non-admins get redirected to '/'. */
export function AdminOnly({ children }: { children: React.ReactNode }) {
  const user = useAppSelector((s) => s.auth.user);
  if (!user || user.role !== "admin") {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
